import variables from '@root/styles/variables';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const StyledPickupLocationListItem = styled.div<{ $disabled?: boolean }>`
  padding: ${rem(16)};
  width: 100%;

  ${(props) =>
    props.$disabled &&
    css`
      color: ${variables.colors.darkGray};
      cursor: default;
    `}
`;
export const StyledStoreInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
